/** Ignore sub-threshold reflows that would thrash zoom. */
export const FIT_SCALE_RESIZE_PX = 12

export const FIT_SCALE_MIN = 0.72
export const FIT_SCALE_MAX = 1

export function computeFitScale(args: {
  containerWidth: number
  containerHeight: number
  contentWidth: number
  contentHeight: number
  minScale?: number
  maxScale?: number
}): number {
  const minScale = args.minScale ?? FIT_SCALE_MIN
  const maxScale = args.maxScale ?? FIT_SCALE_MAX
  if (args.containerWidth < 32 || args.containerHeight < 32) return maxScale
  if (args.contentWidth < 8 || args.contentHeight < 8) return maxScale

  const byWidth = args.containerWidth / args.contentWidth
  const byHeight = args.containerHeight / args.contentHeight
  const next = Math.min(byWidth, byHeight, maxScale)
  return Math.max(minScale, Number(next.toFixed(3)))
}

export function shouldAcceptFitScaleResize(args: {
  prev: { w: number; h: number }
  next: { w: number; h: number }
}): boolean {
  const { prev, next } = args
  if (prev.h === 0 || prev.w === 0) return true
  return (
    Math.abs(prev.w - next.w) > FIT_SCALE_RESIZE_PX ||
    Math.abs(prev.h - next.h) > FIT_SCALE_RESIZE_PX
  )
}
